// async function getConfig() {
//     try {
//         const response = await fetch('/package.json');
//         if (!response.ok) {
//             throw new Error('Error fetching package.json: ' + response.statusText);
//         }
//         const packageJson = await response.json();
//         return packageJson.basketConfig;
//     } catch (error) {
//         console.error('Error loading package.json:', error);
//     }
// }

import {dialogAnimate} from "../modules/validation.js";

let productKey = 'product_id';
let productQuantity = 'quantity';
// const awaitConfigProduct = await getConfig().then(config => {productKey = config.productKey});
// const awaitConfigQuantity = await getConfig().then(config => {productQuantity = config.quantityKey});

class BasketClass{
    constructor(options) {
        this[productKey] = options[productKey],
        this[productQuantity] = options[productQuantity]
    }
}

class BasketCounter extends BasketClass{
    constructor(options) {
        super(options),
        this.counter = options.counter
    }
    counterFunctionality() {
        
    }
}

class AddToBasket extends BasketCounter {
    constructor(options) {
        super(options)

        this[productQuantity] = options[productQuantity]
    }
    addToBasketFunctionality(_this, element) {
        const id = isNaN(this[productKey]) ? this[productKey] : parseInt(this[productKey]);
				window?.digiLayer?.addToCart(id, 1)
        sendData({'product_id': id}, '/api/cart/add_product/').then(res => {
            if (typeof this.updateBadge === 'function') {
                this.updateBadge();
            }
            const cartIcon = document.getElementsByClassName("cart-icon-wrapper")[0];
            if (cartIcon) {
              cartIcon.classList.add("active");
            }
            element.dataset.state = 'active';
            if(_this.activeInnerHTML) element.innerHTML = _this.activeInnerHTML;
            if (typeof ym === 'function') {
                ym(82592749,'reachGoal','addbasket');
            }
            if (typeof _tmr === 'object') {
                _tmr.push({ type: 'reachGoal', id: 3673330, goal: 'addbasket' });
            }
        }).catch((error) =>  {
            dialogAnimate("product-error", 'Товар забронирован.');
        })
    }
}

class DeleteFromBasket extends AddToBasket {
    constructor(options) {
        super(options)
    }
    deleteFromBasketFunctionality() {
        const id = isNaN(this[productKey]) ? this[productKey] : parseInt(this[productKey]);
        const productObj = {};
        productObj[productKey] = id;
        deleteData(productObj, '/api/cart/delete_product/');
    }
}


class BasketLibrary extends DeleteFromBasket{
    constructor(Elem, options) {
        super(options),

        this.$Elem = (typeof Elem === 'string') ? document.querySelector(`${Elem}`) : Elem
        this.$Badge = (typeof options.badge === 'string') ? document.querySelectorAll(`${options.badge}`) : options.badge

        this.options = options || {};
        this.activeInnerHTML = options.activeInnerHTML,
        this.oldInnerHTML = options.oldInnerHTML

        this.buttonFunctionality()
        // this.checkForBasket()
        if(!this.counter) return;
        this.counterFunctionality()
    }

    buttonFunctionality() {
        this.$Elem.addEventListener('click',()=>{
            if(!this.$Elem.dataset.state) {
                this.$Elem.dataset.state = 'unactive';
                if(this.activeInnerHTML) this.$Elem.innerHTML = this.activeInnerHTML;
            }

            if(this.$Elem.dataset.state === 'active') {
                window.location.href = '/basket/'
            } else if(this.$Elem.dataset.state === 'unactive') {
                super.addToBasketFunctionality(this, this.$Elem)
            }

            if(!this.$Badge || this.$Badge.length === 0) return;
        });

        if(!this.$Badge || this.$Badge.length === 0) return;
    }
    updateBadge() {
        getData('/api/cart/')
        .then(res=>{
            for(const badge of this.$Badge) {
                badge.dataset.value = res.total
								badge.dataset.value = res.total
								console.log(res)
            }
        })
    }
}

async function getData(url) {
    const response = await fetch(url, {
        method: "GET",
    });

    if (response.ok) {
        return response.json();
    } else {
        throw new Error(response.statusText);
    }
}

async function deleteData(data, url) {
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            'Content-Type': "application/json",
            'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify(data),
    })
    if(response.ok) return response.json()
    else throw new Error(response.statusText)
}

async function sendData(data, url) {
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': "application/json",
                'X-CSRFToken': csrfToken
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            const result = await response.json();
            console.log(result);
        } else {
            throw new Error(response.statusText);
        }
    } catch (error) {
        console.error("Ошибка при отправке данных:", error);
        throw error;
    }
}

const getCart = () => {
    return getData('/api/cart/')
        .then(res => {
            return res
        })
}

export async function checkForBasket() {
    const basketBtns = document.querySelectorAll('.__add_in_basket');
    const basket = await getCart();
	
    if (!basket.items || basket.items.length === 0) return;

		basket?.items?.forEach(item => {
			window?.digiLayer?.addToCart(item.product_id, item.quantity)
		});

    basketBtns.forEach(btn => {
        const buttonId = parseInt(btn.dataset.id);
        const match = basket.items.some(item => parseInt(item.product_id) === buttonId);

        if (match) {
            btn.dataset.state = 'active';
            btn.innerHTML = 'В корзину';
        } else {
            btn.dataset.state = 'unactive';
            btn.innerHTML = 'Купить';
        }
    });
}

export function getBasketFromCookie() {
    const basketCookies = getCookiesBasket();
    return basketCookies ? JSON.parse(basketCookies) : [];
}

export default BasketLibrary;
